import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import type { Invoice } from '../../types';

// Entity slice type
export interface InvoiceDataReducer {
  ids: string[];
  entities: Record<string, Invoice>;
}

const invoiceAdapter = createEntityAdapter({ selectId: ({ id }: Invoice) => id });

export default createReducer(invoiceAdapter.getInitialState(), {
  [types.FETCH_INVOICE_REQUEST]: invoiceAdapter.removeAll,
  [types.FETCH_INVOICE_SUCCESS]: invoiceAdapter.updateMany
});
